import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import * as Sentry from '@sentry/react';
import { lmsTheme } from '@/theme/lmsTheme';
import { queryClient } from '@/lib/queryClient';
import { AppRoutes } from '@/routes/index';
import { ApiErrorHandler } from '@/components/ApiErrorHandler';

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh.</p>}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={lmsTheme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <CssBaseline />
            <BrowserRouter>
              <AppRoutes />
              <ApiErrorHandler />
            </BrowserRouter>
          </LocalizationProvider>
        </ThemeProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}
